import { useContext, useState } from "react"
import { SidePopupLayout } from "src/component/SidePopupLayout"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import { AbsoluteContainer, AppSpan, AppText, Button, CustomContainer, FlexRow, GridContainer, ScreenTitle } from "src/style"
import { FlightDetails, TxPinVerification } from "src/component"
import {ReactComponent as FlightIcon} from 'src/assets/img/flight-search-icon.svg'
import {ReactComponent as PlaneIcon} from 'src/assets/img/plane-sm.svg'
import {searchedFlights} from 'src/utils/mock-data'

export const SearchedFlights: React.FC<any> = ({close}) => {
    const {notifier} = useContext(VisibilityContext)
    const [selectedFlight, setSelectedFlight] = useState<any>(null)
    const [accountNo, setAccountNo] = useState('')
    const [view, setView] = useState('searched-flights')


    async function handleNext(data: any) {
        setSelectedFlight(data)
        setView('flight-details')
    }

    async function handleSubmit() {
        notifier.show('Transaction Successful', null, 'success')
        close()
    }

    return (
        <>
            { view === 'searched-flights' &&
                <SidePopupLayout close={close}>
                    <ScreenTitle textSize="2.2" fontWeight="700">Flight Search</ScreenTitle>
                    <>
                        {
                            searchedFlights?.map((item, index) => {
                                return (
                                    <GridContainer
                                        minHeight="13.1" radius="0.875" topMargin='2.5'
                                        shadow="0px 4px 20px rgba(0, 0, 0, 0.15)"
                                        padding="1" bgColor="#ffffff" key={index}
                                        onClick={() => handleNext(item)}
                                    >
                                        <AbsoluteContainer top="0.7" left="50" lSizeUnit="%" zIndex="2" className="translate-50perc">
                                            <GridContainer width="auto" sizeUnit="">
                                                <AppSpan textSize="1.07" color="#B9BCB9" fontFamily="Montserrat" bottomMargin="0.5">{item.duration}</AppSpan>
                                                <PlaneIcon className="icon-component" />
                                                <AppSpan textSize="1.07" color="#B9BCB9" fontFamily="Montserrat" topMargin="0.3">Non-Stop</AppSpan>
                                            </GridContainer>
                                        </AbsoluteContainer>
                                        <FlexRow width="90" sizeUnit="%" justifyContent="space-between" gap="1" gapUnit="rem">
                                            <CustomContainer width="auto" sizeUnit="">
                                                <AppSpan textSize="1.25" fontWeight="600" color="#25282B" fontFamily="Montserrat">{item.from}</AppSpan>
                                                <AppText textSize="1.1" color="#25282B" fontWeight="500" fontFamily="Montserrat">{item.startTime}</AppText>
                                            </CustomContainer>
                                            <CustomContainer width="15" style={{border: '0.894768px dashed #DADADA'}}/>
                                            <CustomContainer width="auto" sizeUnit="">
                                                <AppSpan textSize="1.25" fontWeight="600" color="#25282B" fontFamily="Montserrat">{item.to}</AppSpan>
                                                <AppText textSize="1.1" color="#25282B" fontWeight="500" fontFamily="Montserrat">{item.stopTime}</AppText>
                                            </CustomContainer>
                                        </FlexRow>
                                        <FlexRow justifyContent="space-between" gap="1" topMargin="2">
                                            <AppSpan textSize="1.2" fontWeight="500" color="#848786" fontFamily="Montserrat">ET900</AppSpan>
                                            <FlightIcon className="icon-component" />
                                            <AppSpan textSize="1.6" fontWeight="600" color="#14121E" fontFamily="Montserrat">{item.price}</AppSpan>
                                        </FlexRow>
                                    </GridContainer>
                                )
                            })
                        }
                        {/* <FlexRow justifyContent="flex-end" topMargin='2'>
                            <Button 
                                width='6.4' height='4' 
                                borderColor='#0D968F' hoverBgColor='#fff' 
                                hoverColor='#0D968F' titleSize='1.4'
                                onClick={handleNext}
                            >
                                Next
                            </Button>
                        </FlexRow> */}
                    </>
                </SidePopupLayout>
            }
            { view === 'pin' &&
                <TxPinVerification
                    close={close}
                    next={handleSubmit} 
                />
            }
            { view === 'flight-details' &&
                <FlightDetails
                    close={close}
                    data={selectedFlight}
                    handleNext={() => setView('pin')}
                    acctNo={accountNo}
                    handleAcctNo={(data: string) => setAccountNo(data)}
                />
            }
        </>
    )
}